<template>
  <layout-report :renderBackAndForthFooter="false" :isProgressDone="true" :showFooter="false">
    <v-container class="padded" v-if="!isLoading">
      <v-row>
        <v-col cols="12">
          <v-card flat>
            <v-card-title class="text-h4 px-0">
              {{ title }}
            </v-card-title>
            <v-card-subtitle v-html="description" class="pl-0"></v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <notifications />
      <v-row>
        <v-col cols="12" class="px-1">
          <thg-charging-station-table />
        </v-col>
        <v-col class="pb-12">
          <debug :debug="ChargingStations"> </debug>
        </v-col>
        <v-col>
          <debug :debug="MeterReadings"> </debug>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="padded" v-else>
      <v-row>
        <v-card flat max-width="500">
          <v-card-text>
            <p class="display-1 text--primary">{{ $t("report.thgChargingStationOverview.title") }}</p>
            <v-skeleton-loader type="text"></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-row>
      <v-row>
        <v-col offset="0" cols="12">
          <v-card class="mb-10">
            <v-skeleton-loader type="table-heading, table-tbody, table-tfoot"></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-report>
</template>

<script lang="ts">
import Notifications from "@/components/thg/Notifications.vue";
import ThgChargingStationCardIterator from "@/components/thg/ThgChargingStationCardIterator.vue";
import ThgChargingStationTable from "@/components/thg/ThgChargingStationTable.vue";
import Debug from "@/components/utility/Debug.vue";
import LayoutReport from "@/layouts/LayoutReport.vue";
import { PartnerColor } from "@/lib/partnerColor";
import { ChargingStationModule } from "@/store/modules/charging-station.store";
import { MeterReadingModule } from "@/store/modules/meter-reading.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    ThgChargingStationTable,
    ThgChargingStationCardIterator,
    Debug,
    LayoutReport,
    Notifications
  }
})
export default class ThgChargingStationOverview extends Vue {
  isLoading = false;
  partnerColor = new PartnerColor();
  activeView = 0;

  get ChargingStations() {
    return ChargingStationModule.charingStations;
  }

  get MeterReadings() {
    return MeterReadingModule.meterReadings;
  }

  get title() {
    return this.$t("report.thgChargingStationOverview.title");
  }

  get description() {
    return this.$t("report.thgChargingStationOverview.description");
  }

  async mounted() {
    await this.load();
  }

  async load() {
    this.isLoading = true;
    try {
      await ChargingStationModule.getChargingStations();
      await MeterReadingModule.getMeterReadings();
    } catch (e) {
      this.$toast((e as any).message);
    } finally {
      this.isLoading = false;
    }
  }
}
</script>
